import { isLoggedin } from "../helpers/helper";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

type ProtectedRouteProps = {
  children: JSX.Element;
  fallbackPath?: string;
};

const ProtectedRoute = ({
  children,
  fallbackPath = "/",
}: ProtectedRouteProps) => {
  const [isResolved, setIsResolved] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const resolveAuth = async () => {
      const isUserAuthenticated = await isLoggedin();

      if (!isMounted) return;

      setIsAuthenticated(isUserAuthenticated);
      setIsResolved(true);
    };

    resolveAuth();

    return () => {
      isMounted = false;
    };
  }, []);

  if (!isResolved) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={fallbackPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
